import { observer } from 'mobx-react-lite'
import { SkeletonListInfiniteScrollTrigger } from '@/components/SkeletonListInfiniteScrollTrigger'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { JobEventContainer } from '@/features/jobs/details/components/EventsCard/JobEvent/JobEventContainer'
import { JobEventSkeleton } from '@/features/jobs/details/components/EventsCard/JobEvent'
import { ContentError } from '@/components/ContentError'
import { ActivityPane } from '@/features/jobs/details/components/JobSections/ActivityPane'

export interface ActivityPaneContainerProps {
  vm: JobDetailsViewModel
}

export const ActivityPaneContainer = observer(function ActivityPaneContainer({
  vm,
}: ActivityPaneContainerProps) {
  const details = vm.detailsVm

  const renderEvents = () => (
    <>
      {details.events.map((event) => (
        <JobEventContainer compact event={event} key={event.id} />
      ))}
      <SkeletonListInfiniteScrollTrigger
        scroller={details.jobEventsScrollProvider}
        maxSkeletons={8}
      >
        <JobEventSkeleton />
      </SkeletonListInfiniteScrollTrigger>
    </>
  )

  return (
    <ActivityPane>
      {details.jobEventsScrollProvider.fetch.match({
        pending: renderEvents,
        rejected: (err) => (
          <ContentError
            size="section"
            title="An error occurred while loading events."
            error={err}
          />
        ),
        resolved: renderEvents,
      })}
    </ActivityPane>
  )
})
